import { render, staticRenderFns } from "./DashboardControll.vue?vue&type=template&id=e6e330e4"
import script from "./DashboardControll.vue?vue&type=script&lang=js"
export * from "./DashboardControll.vue?vue&type=script&lang=js"
import style0 from "./DashboardControll.vue?vue&type=style&index=0&id=e6e330e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports